<template>
    <item-form
            :model="model"
            :isEditing="false"
            @save-item="addItem">
    </item-form>
</template>

<script>
    import api from '../../api/teelt';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                model: {
                },
            };
        },
        methods: {
            addItem (model) {
                api.addTeelt(model).then(() => {
                    this.$router.replace('/beheer/teelt');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/teelt/New.vue